import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {SeverityLevel} from "@microsoft/applicationinsights-web";

import {appInsights} from "../../../ApplicationInsightsService";
import { setErrorMessage } from '../../../store/formsState';

import app from '../../../app.module.css';
import error from './messageBanners.module.css';

const ErrorSnackbar = () => {
    const dispatch = useDispatch();

    const WAIT = 5000;
    const [isOpen, setIsOpen] = useState(false);

    const errorMessage = useSelector((state) => state.entities.formsState.errorMessage);

    const environmentIndex = useSelector((state) => state.entities.userService.loggedInUser.environment);

    useEffect(() => {
        setIsOpen(errorMessage.length > 0);

        // don't throw error for dev environment so that snackbar can be shown instead of error screen
        if (environmentIndex !== "0" && errorMessage.length > 0) {
            throw new Error(errorMessage);
        } else if (errorMessage.length > 0) {
            appInsights.trackException({ error: new Error(errorMessage), severityLevel: SeverityLevel.Error });
        }
    }, [errorMessage]);

    useEffect(() => {
        if (!isOpen) return;
        const el = document.getElementById('errorMessageEl');
        let fadeoutTimeoutId;
        el && (fadeoutTimeoutId = setTimeout(() => el.classList.add(`${app.fadeout}`), WAIT - 500));
        const timeoutId = setTimeout(() => onClose(), WAIT);
        return () => {
            clearTimeout(timeoutId);
            if(el) clearTimeout(fadeoutTimeoutId);
        };
    }, [isOpen]);

    const onClose = () => {
        dispatch(setErrorMessage(''));
    };

    return !isOpen ? null : (
        <div
            id="errorMessageEl"
            className={`${error.bannerWrapper} ${error.errorWrapper} ${app.fadein}`}
            onClick={onClose}>
            Error: {errorMessage}
        </div>
    );
};

export default ErrorSnackbar;
